"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      d: "M19.148 14.595c-.21.21-.437.332-.682.367a1.038 1.038 0 0 1-.708-.157c-.192-.14-.359-.262-.498-.367a9.212 9.212 0 0 1-.368-.289l.604-2.675c.227.123.48.289.76.498.28.21.577.455.892.735.28.262.42.572.42.93 0 .36-.14.678-.42.958ZM24 9.153v.026a1.35 1.35 0 0 1-.446 1.01c-.28.297-.63.446-1.049.446-.42 0-.796-.131-1.128-.393a18.671 18.671 0 0 0-1.547-1.154 12.473 12.473 0 0 0-1.495-.866l.734-3.016c.857.384 1.661.84 2.413 1.364a22.434 22.434 0 0 1 2.098 1.652c.277.225.417.535.42.931ZM4.854 14.621c-.298-.297-.442-.633-.433-1.01.009-.375.144-.668.406-.878a12.462 12.462 0 0 1 3.2-2.02c1.137-.49 2.405-.743 3.803-.76l-1.678 3.357a4.293 4.293 0 0 0-1.666.42 5.938 5.938 0 0 0-1.403.97c-.297.227-.669.345-1.115.354-.445.009-.817-.135-1.114-.433Zm6.032 5.928c-.49-.21-.861-.616-1.115-1.22-.253-.603-.231-1.184.066-1.744.122-.245.459-.93 1.01-2.059a999.93 999.93 0 0 1 1.836-3.737l1.967-3.987a579.126 579.126 0 0 0 1.403-2.859.84.84 0 0 1 .341-.38.694.694 0 0 1 .55-.066c.21.07.364.184.46.341a.59.59 0 0 1 .065.499c-.157.63-.406 1.66-.747 3.095a457.21 457.21 0 0 1-1.076 4.42c-.376 1.511-.72 2.893-1.036 4.143-.314 1.25-.533 2.006-.655 2.269a2.171 2.171 0 0 1-1.338 1.246c-.63.218-1.206.231-1.73.039ZM.002 9.192c.017.403.166.735.445.997.263.28.608.424 1.036.433a1.73 1.73 0 0 0 1.141-.38 17.228 17.228 0 0 1 4.38-2.65 12.807 12.807 0 0 1 4.984-.996c.28 0 .542.013.787.04.244.025.445.047.603.065l1.442-2.833c-.42-.087-.892-.148-1.416-.183a21.495 21.495 0 0 0-1.416-.053c-2.186 0-4.262.407-6.23 1.22a18.808 18.808 0 0 0-5.363 3.37c-.28.245-.41.568-.393.97Z"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};